import __request__ from "routing/request";
export function read(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.report/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function edit(body, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.report/config", body, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
